import * as React from "react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../components/ui/alert-dialog";
import { getAuthenticationStatusChannel } from "../utils/broadcastMessages";

export const AuthenticationStatusListener = () => {
  const [showModal, setShowModal] = React.useState(false);

  const reloadHandler = () => {
    window.location.reload();
  };

  React.useEffect(() => {
    const authenticationStatusChannel = getAuthenticationStatusChannel();

    const handleAuthenticationStatusChange = (event: MessageEvent) => {
      if (event.data && event.data.action === "logout") {
        setShowModal(true);
      } else if (event.data && event.data.action === "login") {
        window.location.reload();
      }
    };

    authenticationStatusChannel.addEventListener(
      "message",
      handleAuthenticationStatusChange,
    );

    return () => {
      authenticationStatusChannel.removeEventListener(
        "message",
        handleAuthenticationStatusChange,
      );
      authenticationStatusChannel.close();
    };
  }, []);

  return (
    <AlertDialog open={showModal}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Sign-In Required</AlertDialogTitle>
          <AlertDialogDescription>
            You have been logged out of your account. To sign in to Needl again,
            please click the 'Reload' button
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={reloadHandler}>Reload</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
